/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useState } from 'react';
import { css, jsx } from '@emotion/react';
import { useTranslation } from 'react-i18next';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import { Typography as Text } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import BigButton from '../common/BigButton';
import { useDocumentActions } from '../../actions/DocumentActions';

import { track } from '../../utils/track';
import { isValidName } from '../../utils/folders';

export default function UpdateDocumentDialog({ open, onClose, data }) {
  const { t } = useTranslation();
  const [name, setName] = useState(data?.title);
  const { updateDocument } = useDocumentActions(undefined, data?.docId);

  const handleOpen = () => {
    onClose();
  };

  const handleClose = () => {
    setName('');
    onClose();
  };

  const handleChange = (e) => {
    setName(e.target.value);
  };

  const handleSubmit = async (e) => {
    if (!name) return;
    e.preventDefault();
    await updateDocument({
      title: name,
    });
    setName('');
    onClose();
  };

  const validName = isValidName(name);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: '25rem',
        },
      }}
    >
      <DialogTitle>{t('Uppdatera anteckningar')}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={t('Namn')}
          type="text"
          fullWidth
          value={name}
          onChange={handleChange}
          size="small"
          error={!validName}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('Stäng')}</Button>
        <Button onClick={handleSubmit} disabled={!name.length || !validName}>
          {t('Uppdatera')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
